import { render, staticRenderFns } from "./ShareCPDModal.vue?vue&type=template&id=2aa8360c&scoped=true&"
import script from "./ShareCPDModal.vue?vue&type=script&lang=js&"
export * from "./ShareCPDModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8360c",
  null
  
)

export default component.exports